import { cn } from '@shared/lib/utils';
import { InfoTooltip } from '@shared/ui/infoTooltip';
import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface PageHeaderProps {
  title: string;
  description?: string;
  infoTooltip?: string;
  className?: string;
  children?: React.ReactNode;
  onBack?: () => void;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  infoTooltip,
  className,
  children,
  onBack,
}) => {
  return (
    <div className={cn('flex items-start gap-3', className)}>
      {onBack && (
        <button
          onClick={onBack}
          className="p-2 hover:bg-gray-100 rounded-lg transition-all mr-1 flex items-center justify-center self-start"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
      )}
      <div className="flex-1">
        <div className="flex items-start justify-between">
          <div>
            <h1 className="page-title">
              {title}
              {infoTooltip && <InfoTooltip content={infoTooltip} />}
            </h1>
            {description && (
              <p className="page-subtitle">{description}</p>
            )}
          </div>
          {children && <div className="flex items-center space-x-2">{children}</div>}
        </div>
      </div>
    </div>
  );
};
export default PageHeader;
